export const SCHEDULING_VIDEO_URL =
  "https://player.vimeo.com/video/1069627910?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479";
export const RESCHEDULING_VIDEO_URL =
  "https://player.vimeo.com/video/1069627873?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479";
export const CALENDAR_PREFERENCES_VIDEO_URL =
  "https://player.vimeo.com/video/1069627848?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479";
